import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { Placeholder } from '../interfaces/placeholder';
@Directive({
  selector: '[appDynamicPlaceholder]'
})
export class DynamicPlaceholderDirective implements OnChanges {
  @Input() text: Placeholder;
  constructor(private element: ElementRef ) {
  }

  ngOnChanges(changes) {
    if (changes.text && changes.text.currentValue) {
        this.setPlaceholder();
    }
  }

  setPlaceholder() {
    this.element.nativeElement.placeholder = this.text.placeholder;
  }

}
